module.exports = __webpack_public_path__ + "static/img/ice-bag.3c859f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/package-service/ice-bag.png
// module id = CiP6
// module chunks = 2